import { Clock10, Mail, MapPin, Phone } from "lucide-react";

export const Contacts = [
  {
    icon: Mail,
    label: "Email",
    value: "Info@7skypremium.com",
  },
  {
    icon: Phone,
    label: "Phone",
    value: "+971-(0)45-574-139",
    value1:"+98-513-1713"
  },
  {
    icon: MapPin,
    label: "Address",
    value: "No.304, Saeed Tower 1, Dubai",
  },
  { icon: Clock10,
    label: "Hours",
    value: "Sat – Thu · 10:00 – 16:00" }
];
